import {
  AlignBottomIcon,
  ArrowOppositeIcon,
  BriefcaseIcon,
  CalendarIcon,
  ClockIcon,
  CursorIcon,
  GraphIcon,
  UsersCheckIcon,
  UsersIcon,
  WorkflowsIcon,
} from '@persona-id/design-tokens/icons';

import { DisabledProductPageProps } from 'dashboard/components/DisabledProductPage/DisabledProductPage';
import AnalyticsIntroImage from 'images/icons/product-intro/analytics-intro-image.svg';
import CasesIntroImage from 'images/icons/product-intro/cases-intro-image.svg';

export const DISABLED_CASES_PAGE: DisabledProductPageProps = {
  id: 'cases',
  title: 'Empower your team to make manual review decisions more accurately and efficiently',
  headerTitle: 'Cases',
  description:
    'Built to tackle everything from routine review to your toughest edge cases, our purpose-built and customizable identity investigation tool empowers your team to make manual review decisions more accurate, efficiently, and seamlessly.',
  image: CasesIntroImage,
  uses: [
    {
      icon: GraphIcon,
      usesTitle: 'Avoid unnecessary review caseload.',
      usesDescription:
        'Set your ideal automation threshold to investigate complex cases and automate simple cases better.',
    },
    {
      icon: UsersIcon,
      usesTitle: 'Easily set up and customize your process.',
      usesDescription:
        'Reduce migration burden and configure everything from advanced case assignments to role-specific permissions.',
    },
    {
      icon: WorkflowsIcon,
      usesTitle: 'Opt into a one-stop shop for investigations.',
      usesDescription:
        'Unlock efficiency and productivity for your team by having all the context you need in one window.',
    },
  ],
};

export const DISABLED_INQUIRIES_ANALYTICS_PAGE: DisabledProductPageProps = {
  id: 'inquiries_analytics',
  title: 'Monitor and gain insight into key Inquiry metrics with Analytics',
  headerTitle: 'Inquiries Analytics',
  description:
    'Explore inquiry data insights to leverage Persona’s identity platform more effectively. Turn actionable data into quick-win conversion optimization opportunities.',
  image: AnalyticsIntroImage,
  uses: [
    {
      icon: GraphIcon,
      usesTitle: 'Be the first to spot anomalies.',
      usesDescription:
        'Quickly investigate fluctuations in metrics that may impact conversion rates.',
    },
    {
      icon: WorkflowsIcon,
      usesTitle: 'Drill into the user funnel to analyze drop-off.',
      usesDescription:
        'Use funnel visualization to determine where users are dropping off within your dynamic flow identify opportunities to optimize the user experience.',
    },
    {
      icon: CalendarIcon,
      usesTitle: 'Continuously optimize and iterate.',
      usesDescription:
        'Measure metrics over time and test template changes to create the optimal balance between conversion and friction.',
    },
  ],
};

export const DISABLED_VERIFICATIONS_ANALYTICS_PAGE: DisabledProductPageProps = {
  id: 'verifications_analytics',
  title: 'Uncover actionable insights to decision on verification checks and optimize pass rates',
  headerTitle: 'Verifications Analytics',
  description:
    'Analyze verification volume and individual verification checks to gain visibility into key factors that prevent your users from successfully completing the verification.',
  image: AnalyticsIntroImage,
  uses: [
    {
      icon: AlignBottomIcon,
      usesTitle: 'Track trends over time.',
      usesDescription:
        'Observe key metrics across verification types and inquiry templates to tap into how your verifications are performing.',
    },
    {
      icon: ArrowOppositeIcon,
      usesTitle: 'Compare pass rates across various dimensions.',
      usesDescription:
        'Use Verification Filters to hone in on attributes such as Capture Method, Issuing Country, and more to deeply understand users.',
    },
    {
      icon: UsersCheckIcon,
      usesTitle: 'Make decisions on verification checks.',
      usesDescription:
        'Examine which required verification checks have low pass rates and may be hindering your users’ ability to complete the flow successfully.',
    },
  ],
};

export const DISABLED_REPORTS_ANALYTICS_PAGE: DisabledProductPageProps = {
  id: 'reports_analytics',
  title: 'Make informed report configuration decisions',
  headerTitle: 'Reports Analytics',
  description:
    'Explore aggregated Reports metrics to understand trends in ready rates and match rates for each report type.',
  image: AnalyticsIntroImage,
  uses: [
    {
      icon: AlignBottomIcon,
      usesTitle: 'Monitor fluctuations in match rate over time.',
      usesDescription:
        'Analyze how recent report template configurations have impacted your metrics, while identifying additional opportunities to optimize your strategy.',
    },
    {
      icon: ArrowOppositeIcon,
      usesTitle: 'Compare match rates across different report templates.',
      usesDescription:
        'Test how the same Report type performs across different templates to optimize report configuration decisions.',
    },
    {
      icon: BriefcaseIcon,
      usesTitle: 'Reduce manual review load from false positives.',
      usesDescription:
        'Respond to jumps in false positives with configuration tweaks, so your team is not burdened by an increased manual review load.',
    },
  ],
};

export const DISABLED_CASES_ANALYTICS_PAGE: DisabledProductPageProps = {
  id: 'cases_analytics',
  title:
    'Track your manual review team’s productivity metrics and identify ways to drive efficiency',
  headerTitle: 'Cases Analytics',
  description:
    'Stay informed on case resolution outcomes and discover opportunities to reduce manual review load.',
  image: AnalyticsIntroImage,
  uses: [
    {
      icon: AlignBottomIcon,
      usesTitle: 'Get robust reporting of your cases.',
      usesDescription:
        'Monitor metrics such as total cases resolved, number of pending cases, and percentage of declined cases for easy internal reporting.',
    },
    {
      icon: ClockIcon,
      usesTitle: 'Monitor fluctuations in case volumes.',
      usesDescription:
        'Understand case volume trends by case tags and better automate your decision making.',
    },
    {
      icon: CursorIcon,
      usesTitle: 'Gain insight into your team’s performance.',
      usesDescription:
        'Understand opportunities to help your team improve by observing individual and overall team metrics.',
    },
  ],
};
